"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFlowRate = exports.calculateVolume = exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.FlowRate = exports.UsFlowRate = exports.UsFluidOuncesPerSecond = exports.UsFluidOuncesPerMinute = exports.SiFlowRate = exports.LitersPerSecond = exports.LitersPerMinute = exports.DecilitersPerSecond = exports.DecilitersPerMinute = exports.MillilitersPerSecond = exports.MillilitersPerMinute = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Time = __importStar(require("./time"));
const Volume = __importStar(require("./volume"));
exports.NAMESPACE = 'Unit.FlowRate';
exports.MillilitersPerMinute = effect_1.Schema.TaggedStruct('MillilitersPerMinute', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.MillilitersPerMinute` });
exports.MillilitersPerSecond = effect_1.Schema.TaggedStruct('MillilitersPerSecond', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.MillilitersPerSecond` });
exports.DecilitersPerMinute = effect_1.Schema.TaggedStruct('DecilitersPerMinute', {
    amount: effect_1.Schema.Number,
}).annotations({ identifier: `${exports.NAMESPACE}.DecilitersPerMinute` });
exports.DecilitersPerSecond = effect_1.Schema.TaggedStruct('DecilitersPerSecond', {
    amount: effect_1.Schema.Number,
}).annotations({ identifier: `${exports.NAMESPACE}.DecilitersPerSecond` });
exports.LitersPerMinute = effect_1.Schema.TaggedStruct('LitersPerMinute', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.LitersPerMinute` });
exports.LitersPerSecond = effect_1.Schema.TaggedStruct('LitersPerSecond', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.LitersPerSecond` });
exports.SiFlowRate = effect_1.Schema.Union(exports.MillilitersPerMinute, exports.MillilitersPerSecond, exports.DecilitersPerMinute, exports.DecilitersPerSecond, exports.LitersPerMinute, exports.LitersPerSecond).annotations({
    identifier: `${exports.NAMESPACE}.SiFlowRate`,
});
exports.UsFluidOuncesPerMinute = effect_1.Schema.TaggedStruct('UsFluidOuncesPerMinute', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.UsFluidOuncesPerMinute` });
exports.UsFluidOuncesPerSecond = effect_1.Schema.TaggedStruct('UsFluidOuncesPerSecond', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.UsFluidOuncesPerSecond` });
exports.UsFlowRate = effect_1.Schema.Union(exports.UsFluidOuncesPerMinute, exports.UsFluidOuncesPerSecond).annotations({
    identifier: `${exports.NAMESPACE}.UsFlowRate`,
});
exports.FlowRate = effect_1.Schema.Union(...exports.SiFlowRate.members, ...exports.UsFlowRate.members).annotations({
    identifier: `${exports.NAMESPACE}.FlowRate`,
});
exports.LABEL_MAP_SINGULAR = {
    // SI
    MillilitersPerMinute: 'milliliter per minute',
    MillilitersPerSecond: 'milliliter per second',
    DecilitersPerMinute: 'deciliter per minute',
    DecilitersPerSecond: 'deciliter per second',
    LitersPerMinute: 'liter per minute',
    LitersPerSecond: 'liter per second',
    // US
    UsFluidOuncesPerMinute: 'fluid ounce per minute',
    UsFluidOuncesPerSecond: 'fluid ounce per second',
};
exports.LABEL_MAP_PLURAL = {
    // SI
    MillilitersPerMinute: 'milliliters per minute',
    MillilitersPerSecond: 'milliliters per second',
    DecilitersPerMinute: 'deciliters per minute',
    DecilitersPerSecond: 'deciliters per second',
    LitersPerMinute: 'liters per minute',
    LitersPerSecond: 'liters per second',
    // US
    UsFluidOuncesPerMinute: 'fluid ounces per minute',
    UsFluidOuncesPerSecond: 'fluid ounces per second',
};
/**
 * Retrieves the label corresponding to a given {@link FlowRate}-tag
 */
const getLabel = (flowRate) => flowRate.amount === 1 ? exports.LABEL_MAP_SINGULAR[flowRate._tag] : exports.LABEL_MAP_PLURAL[flowRate._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    // SI
    MillilitersPerMinute: 'mL/min',
    MillilitersPerSecond: 'mL/s',
    DecilitersPerMinute: 'dL/min',
    DecilitersPerSecond: 'dL/s',
    LitersPerMinute: 'L/min',
    LitersPerSecond: 'L/s',
    // US
    UsFluidOuncesPerMinute: 'fl oz/min',
    UsFluidOuncesPerSecond: 'fl oz/sec',
};
/**
 * Retrieves the symbol corresponding to a given {@link FlowRate}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link MillilitersPerMinute} and other {@link FlowRate} unit of measure
 */
const FACTOR_MAP = {
    // SI
    MillilitersPerMinute: 1,
    MillilitersPerSecond: 60,
    DecilitersPerMinute: 100,
    DecilitersPerSecond: 6_000,
    LitersPerMinute: 1_000,
    LitersPerSecond: 60_000,
    // US
    UsFluidOuncesPerMinute: 29.5735,
    UsFluidOuncesPerSecond: 1_774.41,
};
/**
 * Converts any {@link FlowRate} to a specific flow-rate measure
 */
exports.convert = effect_1.Function.dual(2, (flowRate, outTag) => {
    const millilitersPerMinute = flowRate.amount * FACTOR_MAP[flowRate._tag];
    return {
        _tag: outTag,
        amount: millilitersPerMinute / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link FlowRate} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (flowRate, ...args) => effect_1.Array.reduce(args, flowRate, (acc, flowRate) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(flowRate, acc._tag).amount,
}));
exports.sum = sum;
/**
 * Calculates how much {@link Volume.Volume Volume} (expressed in {@link Volume.Milliliter Milliliter})
 * was displaced over the specified period of {@link Time.Time Time},
 * assuming the provided {@link FlowRate}.
 */
const calculateVolume = (flowRate, time) => {
    const millilitersPerSecond = (0, exports.convert)(flowRate, 'MillilitersPerSecond');
    const seconds = Time.convert(time, 'Second');
    return Volume.Milliliter.make({ amount: millilitersPerSecond.amount * seconds.amount });
};
exports.calculateVolume = calculateVolume;
/**
 * Calculates the average {@link FlowRate} (expressed in {@link MillilitersPerSecond})
 * when the specified {@link Volume.Volume Volume}
 * was displaced over the specified period of {@link Time.Time Time}.
 */
const calculateFlowRate = (volume, time) => {
    const milliliters = Volume.convert(volume, 'Milliliter');
    const seconds = Time.convert(time, 'Second');
    return exports.MillilitersPerSecond.make({ amount: milliliters.amount / seconds.amount });
};
exports.calculateFlowRate = calculateFlowRate;
//# sourceMappingURL=flow-rate.js.map